<script setup lang="ts">
import { useModalStore } from '../../ui/modal/modal-store';
const modal = useModalStore()

function close(isDisabled: boolean) {
    if (isDisabled) {
        return;
    }
    modal.cancel();
}

function onContentMounted(vnode) {
    const node = vnode.el as Node;
    if (!node) return;
    const el = (node.nodeType === Node.ELEMENT_NODE ? node as HTMLElement : node.parentElement);
    const container = el?.closest<HTMLElement>('.modal-content');
    if (!container) return;
    const target = container.closest<HTMLElement>('.modal');
    target?.focus();
}

</script>

<template>
    <div v-for="(item, index) in modal.stack" :key="index">
        <div class="modal fade in" :style="{ zIndex: 1050 + index * 10 }" tabindex="-1"
            @keydown.esc="() => close(item.disableEscape)">
            <div class="modal-dialog" :class="item.size ? `modal-${item.size}` : ''">
                <div class="modal-content">
                    <component :is="item.component" v-bind="item.props" @vue:mounted="onContentMounted" />
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in" :style="{ zIndex: 1040 + (index && 1 || 0) + index * 10 }"></div>
    </div>
</template>
